import { ReactNode } from "react";
import { Card, CardContent, Box, Typography } from "@mui/material";

interface StatCardProps {
  title: string;
  value: string | number;
  icon?: ReactNode;
  description?: string;
  highlight?: boolean;
  compact?: boolean;
  accentColor?: string;
  action?: ReactNode;
}

export function StatCard({ title, value, icon, description, highlight, compact, accentColor, action }: StatCardProps) {
  return (
    <Card
      variant="outlined"
      sx={{
        height: "100%",
        borderColor: highlight ? "primary.main" : accentColor ?? undefined,
        backgroundColor: highlight ? "rgba(33,150,243,0.05)" : undefined,
      }}
    >
      <CardContent sx={{ p: compact ? 1.5 : 2.5 }}>
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={0.5}>
          <Typography
            variant="caption"
            sx={{ textTransform: "uppercase", letterSpacing: 0.5, color: "text.secondary", fontWeight: 600 }}
          >
            {title}
          </Typography>
          {icon && <Box sx={{ color: accentColor ?? "primary.main", display: "flex" }}>{icon}</Box>}
        </Box>
        <Typography variant={compact ? "h6" : "h5"} sx={{ fontWeight: 700, fontFamily: "monospace" }}>
          {value}
        </Typography>
        {description && (
          <Typography variant="caption" color="text.secondary">
            {description}
          </Typography>
        )}
        {action && <Box mt={0.5}>{action}</Box>}
      </CardContent>
    </Card>
  );
}
